<template>
	<div class="notice_popup human">
		<div class="close">
			<img src="/images/close.png" alt="닫기" @click="$emit('close')"/>
		</div>
		<div class="tit" style="margin-left: 0;">해당 IT프로는 탈퇴회원입니다.</div>		
		<div class="select-btn">
			<div class="btn" style="background-color: #75A5BF;" @click="$emit('close')">닫기</div>
		</div>
	</div>
</template>
<script>
export default {
	data() { return { } },
    methods: { }
}
</script>